/* Neanour: lange teksten onder de koopsectie op mobiel inklappen met "Read more". Niets wordt verwijderd. */
(function () {
  var mq = window.matchMedia('(max-width: 767px)');
  var S = window.neaStrings || { readMore: 'Read more', readLess: 'Read less' };

  function setup() {
    if (!mq.matches) return;
    document.querySelectorAll('[id*="image_with_text"] .m-richtext__description').forEach(function (el) {
      if (el.dataset.neaClamp || el.scrollHeight <= 200) return;
      el.dataset.neaClamp = '1';
      el.classList.add('nea-clamp');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nea-clamp__toggle';
      btn.textContent = S.readMore;
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation(); // niet ook de Vitals-popup openen
        var open = el.classList.toggle('is-open');
        btn.textContent = open ? S.readLess : S.readMore;
        btn.setAttribute('aria-expanded', String(open));
      });
      el.insertAdjacentElement('afterend', btn);
    });
  }

  if (document.readyState !== 'loading') setup();
  else document.addEventListener('DOMContentLoaded', setup);
})();

/* Neanour: lijstnaam zichtbaar onder elk rondje (Black / Wood / Brown) */
(function () {
  function names() {
    document.querySelectorAll('variant-color .m-product-option--node[data-value]').forEach(function (node) {
      if (node.querySelector('.nea-swatch-name')) return;
      var span = document.createElement('span');
      span.className = 'nea-swatch-name';
      span.setAttribute('aria-hidden', 'true');
      const nlShort = { zwarte: 'Zwart', witte: 'Wit', houten: 'Hout', bruine: 'Bruin' };
      const short = node.dataset.value.replace(/\s*(frame|lijst)$/i, '');
      span.textContent = /^(no|geen|zonder)$/i.test(short) ? node.dataset.value : (nlShort[short.toLowerCase()] || short);
      node.appendChild(span);
    });
  }
  if (document.readyState !== 'loading') names();
  else document.addEventListener('DOMContentLoaded', names);
})();

/* Lange reviews: na 5 regels afkappen met "Read more" (Vitals laadt reviews later en bij "See more"). */
(function () {
  var LIMIT = 5;
  function clampAll(root) {
    root.querySelectorAll('.vtl-pr-ri__message:not([data-nea-clamp])').forEach(function (msg) {
      msg.setAttribute('data-nea-clamp', '');
      msg.classList.add('nea-clamp');
      if (msg.scrollHeight - msg.clientHeight < 4) { msg.classList.remove('nea-clamp'); return; }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nea-readmore';
      btn.textContent = 'Read more';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var open = msg.classList.toggle('nea-clamp') === false;
        btn.textContent = open ? 'Show less' : 'Read more';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      msg.insertAdjacentElement('afterend', btn);
    });
  }
  function start() {
    var root = document.getElementById('bundle-product_reviews');
    if (!root) return;
    clampAll(root);
    new MutationObserver(function () { clampAll(root); }).observe(root, { childList: true, subtree: true });
  }
  document.documentElement.style.setProperty('--nea-review-lines', LIMIT);
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
